const STORAGE_KEY = 'erp4c_remember_userid';

/**
 * Persist login email for N days when "Remember me" is checked.
 * @returns {{ email: string, expiresAt: number } | null}
 */
export function loadRememberedUserid() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const email = String(parsed?.email || '').trim();
    const expiresAt = Number(parsed?.expiresAt);
    if (!email || !Number.isFinite(expiresAt)) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    if (Date.now() > expiresAt) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return { email, expiresAt };
  } catch {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function saveRememberedUserid(email, days) {
  const clean = String(email || '').trim();
  const d = Math.max(1, parseInt(String(days ?? 14), 10) || 14);
  if (!clean) {
    clearRememberedUserid();
    return;
  }
  const expiresAt = Date.now() + d * 24 * 60 * 60 * 1000;
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ email: clean, expiresAt, days: d }));
}

export function clearRememberedUserid() {
  localStorage.removeItem(STORAGE_KEY);
}
